
import { transactionService } from "../../services/transaction.service";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import underscore from "underscore";
import { useRecoilValue } from "recoil";
import { transactionmasterDataAtom } from "../../store/transAtom";
import { Table, Input } from 'antd';
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
const { Search } = Input;




function InvoiceContent(props) {
  const [invoiceList, setInvoiceList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const masterData = useRecoilValue(transactionmasterDataAtom);
  var masterDataGroup = underscore.groupBy(masterData, "Master_Type");
  const invoiceStatus = masterDataGroup[3];
  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];



  useEffect(() => {
    transactionService.getTransactionInvoice(props.customer_id).then((res) => {
      let listInvoice = [];
      if (res?.data !== undefined) {
        listInvoice = res?.data?.map((invoice, index) => {
          return { ...invoice,  Amount: formatCustomNumber(invoice?.Amount), Invoice_Ref_No: invoice.Invoice_Ref_No?.toString(),
            Order_NO: invoice?.Order_NO?.toString()
           };
        });
      }
      setInvoiceList(listInvoice);
      setFilteredData(listInvoice);
    });
  }, [props.customer_id]);

  function statusSelectHandler(value) {
    if (value === "All") {
      return setFilteredData(invoiceList);
    } else {
      var tempList = invoiceList?.filter(
        (item) => item.Invoice_Status === value
      );
      setFilteredData(tempList);
    }
  }





  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: filteredData?.length || 0,
    // onChange: (page, pageSize) => {
    //   const newList = tableDataList.slice(0, pageSize);
    //   setTableList(newList);
    // },
  };



const columns = [
  {
    title: 'Invoice Ref',
    // key: 'Order_NO',
    dataIndex: 'Invoice_Ref_No',
    className: "text-primary font-bold",
    sorter: (a, b) => a.Invoice_Ref_No.localeCompare(b.Invoice_Ref_No)
  },

  {
    title: "Invoice Number",
    dataIndex: "Invoice_No",
    sorter: (a, b) => a.Invoice_No.localeCompare(b.Invoice_No)
  },

  {
    title: "Date",
    dataIndex: "Invoice_Date",
    sorter: (a, b) => a.Invoice_Date.localeCompare(b.Invoice_Date)
  },
  {
    title: "Amount",
    dataIndex: "Amount",
    sorter: (a, b) => a.Amount.localeCompare(b.Amount)
  },
  {
    title: "Status",
    dataIndex: "Invoice_Status",
    sorter: (a, b) => a.Invoice_Status.localeCompare(b.Invoice_Status)
  },
];

const handleSearch = (value) => {
  setSearchText(value);
  const filtered = invoiceList.filter((record) =>
    Object.values(record).some((text) =>
      String(text).toLowerCase().includes(value.toLowerCase())
    )
  );
  setFilteredData(filtered);
};

const handleRowClick = (record) => {
  const customerRoute = `/${currModuleId}/${currModuleName}/invoices/details/${record?.Invoice_Ref_No}`;
  // Option A: Open in new tab using window.open()
  window.open(customerRoute, '_blank');

};





  return (
    <>
      <div className="ml-1 @container">
        <div className="mt-1 text-gray-600 text-xl font-bold">Invoice</div>
        <div className="mt-2 space-y-3 @lg:flex @lg:flex-row @lg:items-center @lg:justify-between @lg:space-y-0 @lg:space-x-2">
        
        </div>

      
        <Search
        placeholder="Search..."
        onSearch={handleSearch}
        onChange={(e) => handleSearch(e.target.value)}
        value={searchText}
        style={{ marginBottom: 10, width: 250 }}
      />

        <Table key={filteredData?.length} columns={columns} dataSource={filteredData}
                      pagination={paginationOptions}
                      rowClassName="show-cursor"
                      style={{ background: '#f0f2f5', borderRadius: '8px' }}
                      onRow={(record) => {
                        return {
                          onClick: () => {
                            handleRowClick(record);
                          },
                        };
                      }}
                        />
     
      </div>
    </>
  );
}

export default InvoiceContent;
